import script from "./tracking-gtm.vue?vue&type=script&lang=js"
export * from "./tracking-gtm.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__